import React, { useEffect, useState } from 'react';
import './newabout.css';
import img3 from '../../assets/aboutusimage/pexels-fauxels-3184431.jpg';
import img2 from '../../assets/newabout.jpg';
import img1 from '../../assets/aboutusimage/pexels-cottonbro-7438102.jpg';
import img4 from "../../assets/aboutusimage/young-person-intership.jpg"
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';
function Newabout() {

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);


    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });

        setTimeout(() => {
            AOS.refresh();
        }, 500);
    }, []);
    return (
        <>
            <div className="container about-us-section py-1">

                <div className="row align-items-center">

                    {/* Left Side Image + Badge */}
                    <div className="col-md-3 text-center">
                        <div className="mb-4" data-aos='fade-right' data-aos-left='1000'>
                            <img src={img1} alt="Study" className="img-fluid shadow"
                                style={{ borderRadius: "60px 60px 0px 60px " }}
                            />
                        </div>
                       
                    </div>

                    {/* Center Images */}
                    <div className="col-md-3 text-center">
                        <div className="mb-4" data-aos='fade-left' data-aos-left='1000'>
                            <img src={img2} alt="Students" className="img-fluid shadow"
                                style={{ borderRadius: "420%" }} />
                        </div>
                        <div data-aos='fade-up' data-aos-left='1000'>
                            <img src={img4} alt="Teacher" className="img-fluid shadow"
                                style={{ borderRadius: " 0px 80px 0px 80px" }} />
                        </div>
                    </div>
                    {/* <div className="col-md-">

                   </div> */}

                    {/* Right Content */}
                    <div className="col-md-6">
                        <section className='section-margin'>
                            <center>
                                <div className='heading-for-all' data-aos='fade-up'>
                                    <h2>About ELECTIAA</h2>
                                </div>
                            </center>
                        </section>

                        <h3 className="fw-bold">

                            Transform your online presence <br />
                            <span className="text-change">Electiaa </span> delivers results.
                        </h3>
                        <p>
                            With a focus on creativity, functionality, and strategic marketing,  <span className="text-change">Electiaa </span> delivers designs that not only look good, but work hard for you. Whether you're a startup or an established brand, we tailor our strategies to fit your unique voice and vision.
                        </p>

                        <ul>
                            <li> Robust, user-friendly online stores designed to convert visitors into loyal customers.</li>
                            <li> Memorable and meaningful logos that reflect your brand identity.</li>
                            <li> Unique, elegant digital invitations and creative designs for events and promotions.</li>
                            <li> Creative and consistent campaigns to build community and boost brand engagement.</li>
                            <li> Optimize your presence and rise to the top of search engine results.</li>
                            <li> Crafting a distinct, consistent brand voice and identity that resonates and endures.</li>
                        </ul>

                        <div className="container d-flex justify-content-center my-4"
                         data-aos='fade-up' data-aos-left='2000'
                        >
                            <button className="button-all" onClick={handleShow}>
                                Get Enquiry
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <Formpage show={show} onClose={handleClose} />
        </>
    );
}

export default Newabout;
